module.exports = __webpack_public_path__ + "static/media/logo-full.b7440c3a.svg";